export default "__VITE_ASSET__DJvpYs4p__"